import React from 'react';

import { useGetCartProductQuantity } from '~/src/common/hooks/cart/useGetCartProductQuantity';
import I18n from '~/src/common/services/I18n';
import colors from '~/src/common/themes/main/colors';
import { ProductDetailed } from '~/src/common/typings/product';
import { formatBatchDiscountLabel, formatPromoLabel } from '~/src/common/utils/prices';
import { getProductPromoWithBulkDiscount } from '~/src/common/utils/product';
import { getPromoDateConditions } from '~/src/common/utils/promo.utils';

import * as S from './layout';

interface Props {
  className?: string;
  product: ProductDetailed;
  freeQuantity: number;
}

export const ProdutPromo = (props: Props) => {
  const cartQuantity = useGetCartProductQuantity({ sku: props.product.sku, id: props.product.id });

  const promo = getProductPromoWithBulkDiscount(props.product);

  if (promo == null) return null;

  const range = getPromoDateConditions(promo);

  const isBatchDiscount = promo?.mechanism === 'BATCH_DISCOUNT';

  return (
    <S.Promo>
      <S.PromoTag
        className={props.className}
        color={colors.PROMOTION}
        textColor={colors.BLACK}
        $isBatchDiscount={isBatchDiscount}>
        {isBatchDiscount
          ? formatBatchDiscountLabel(promo, cartQuantity - props.freeQuantity)
          : formatPromoLabel(promo, props.product.itemPrice)}
      </S.PromoTag>

      {range != null ? (
        <S.PromoRange>
          {I18n.t(
            range.startDate === range.endDate
              ? 'view-product-screen.promo-day'
              : 'view-product-screen.promo-range',
            range,
          )}
        </S.PromoRange>
      ) : null}
    </S.Promo>
  );
};
